import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import XEUtils from 'xe-utils'
import httpManager from '../../util/common'
import companySearch from '../../home/components/CompanySearch'
import {reportYear} from '../../util/util'
import RevenuePropFilter from '@/common/components/RevenuePropFilter'


Vue.use('vxe-table')
let vm = {
  name: 'IndustrialChainFilter',
  data: () => {
    return {
      loading: false,
      page: {
        layouts: ['PrevPage', 'Number', 'NextPage'],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        align: 'center',
        perfect: true,
        pagerCount: 3
      },
      // 表格数据
      data: [],
      // 行业选项
      industry_options: [
        {
          name:'gics',
          label: 'GICS行业',
          value: '0080008',
          children: []
        },
        {
          name:'citics',
          label: '中信行业',
          value: '0089001',
          children: []
        },
        {
          name:'swhy',
          label: '申万行业',
          value: '0080003',
          children: []
        },
        {
          name:'csin',
          label: '中证行业',
          value: '0080014',
          children: []
        },
        {
          name:'csrc',
          label: '国民经济行业',
          value: '0080001',
          children: []
        }
      ],
      en_industry_options:[
        {
          name:'gics',
          label: 'gics',
          value: '0080008',
          children: []
        },
        {
          name:'citics',
          label: 'citics',
          value: '0089001',
          children: []
        },
        {
          name:'swhy',
          label: 'swhy',
          value: '0080003',
          children: []
        },
        {
          name:'csin',
          label: 'csin',
          value: '0080014',
          children: []
        },
        {
          name:'csrc',
          label: 'csrc',
          value: '0080001',
          children: []
        }
      ],
      zh_industry_options: [
        {
          name:'gics',
          label: 'GICS行业',
          value: '0080008',
          children: []
        },
        {
          name:'citics',
          label: '中信行业',
          value: '0089001',
          children: []
        },
        {
          name:'swhy',
          label: '申万行业',
          value: '0080003',
          children: []
        },
        {
          name:'csin',
          label: '中证行业',
          value: '0080014',
          children: []
        },
        {
          name:'csrc',
          label: '国民经济行业',
          value: '0080001',
          children: []
        }
      ],
      industry: null,
      // 概念标签
      concept_label_options:  [],
      // 年份
      fil_year_options: [],
      revenue_proportion_options: [],
      // 概念标签
      product_label: ["光伏","光伏电力"],
      // 上市公司
      short_name: null,
      // 年份
      end_date: null,
      // 营收占比
      product_label_revper_pre: null,
      product_label_revper_back: null,
      // 行业标签
      industry_option: null,
      follow_entity_supplier: false,
      // 排序
      order_col: null,
      asc_order: null,
      isGreen: false
    }
  },
  methods: {
    openDataExport() {
      let s = "产业链"
      this.$refs.xTable_data.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv'],
        modes: ['current']
      })
    },
    getYear(n) {
      const arr = []
      const date = new Date()
      const curDate = date.getFullYear()
      for (let i = 0; i < n; i++) {
        arr.push({ label:`${curDate - i}`, value: curDate - i})
      }
      this.fil_year_options = arr
    },
    changeMin(value) {
      this.product_label_revper_pre = value
    },
    changeMax(value) {
      this.product_label_revper_back = value
    },
    clearData() {
      this.$refs.revenuePropRef.clear()
      this.industry_option = null
      this.short_name = null
      this.product_label = null
      this.end_date = null
      this.industry = null
      this.order_col = null
      this.asc_order = null
      this.$refs.xTable_data.clearSort()
      this.$refs.companySearch.clear()
      this.$nextTick(() => {
        this.product_label_revper_pre = null
        this.product_label_revper_back = null
      })
    },
    searchData() {
      if (this.product_label === null || this.product_label.length === 0) {
        return this.$message.warning(this.$t('tips.industrial_filter_warning_tip'));
      }
      
      this.isGreen = this.product_label[0] === '绿色产品'
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getIndustrialChainFilterData()
    },
    gicsFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    // 排序按钮事件
    sortChangeEvent({ column, property, order }){
      this.order_col = property
      this.asc_order= order
      if (!this.asc_order) {
        this.order_col = null
      }
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getIndustrialChainFilterData()
    },
    cellClickEvent() {},
    // 页面变化
    pageChange({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getIndustrialChainFilterData()
    },
    headerCellClickEvent() {},
    //时间戳转换成标准时间
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear();
      return Y;
    },
    washTree(tree) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].children) {
          this.washTree(tree[i].children)
        }
        if (tree[i].label === '' && tree[i].value === '') {
          tree.splice(i, 1)
        }
      }
    },
    getStatisticsData () {
      let self = this
      let lang = this.$i18n.locale
      let arr = []
      for (let i = 0; i < self.industry_options.length; i++) {
        let Promise = reportYear.gics_industry(`${self.industry_options[i].name}_industry_tree_` + lang, self.industry_options[i].name).then(result => {
          self.industry_options[i].children = result
          self.en_industry_options[i].children = JSON.parse(sessionStorage.getItem(`${self.industry_options[i].name}_industry_tree_en`))
          self.zh_industry_options[i].children = JSON.parse(sessionStorage.getItem(`${self.industry_options[i].name}_industry_tree_zh`))
        })
        arr.push(Promise)
      }
      let promise2 = httpManager('industry_chain_labels').then((response) => {
        const res = response.data.data
        const arr3 = []
        const arr2 = []
        for (let i = 0; i < res.length; i++) {
          if (!arr2.includes(res[i].first_class)) {
            arr2.push(res[i].first_class)
            arr3.push({label: res[i].first_class, value: res[i].first_class, children: []})
          }
        }
        for (let i = 0; i < res.length; i++) {
          const row = arr3.find(item => item.label === res[i].first_class)
          if (res[i].second_class === '绿色产业绿色产品') continue
          row.children.push({label: res[i].second_class, value: res[i].second_class})
        }
        self.concept_label_options = arr3
      })
      arr.push(promise2)
      return arr 
    },
    // 获取表格数据
    getIndustrialChainFilterData() {
      let self=this
      self.loading=true
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      params.set('percent_min', self.product_label_revper_pre ? self.product_label_revper_pre : 0)
      params.set('percent_max', self.product_label_revper_back ? self.product_label_revper_back : 100)
      if (self.product_label) {
        const isGreen = self.product_label[0] === '绿色产品' ? 'green' : 'not_green'
        const label = self.product_label[self.product_label.length - 1]
        params.set("concept", isGreen)
        params.set("label", label)
      }
      if (self.short_name) {
        params.set("oaid", self.short_name)
      }
      if (self.end_date) {
        params.set("year", self.end_date)
      }
      if(self.industry_option){
        if (self.industry_option[1]) {
          const industry_type = self.industry_option[0]
          const industry_code = self.industry_option[self.industry_option.length - 1]
          params.set("industry_type", industry_type)
          params.set("industry_code", industry_code)
        }
      }
      if(self.order_col){
        params.set('order_col', self.order_col)
      }
      if(self.asc_order){
        params.set('asc_order', self.asc_order === 'asc' ? true : false)
      }
      httpManager("industry_chain_entity_filter",params,null,null,null)
      .then(response=>{
        self.data=response.data.data
        const isGreen = self.product_label[0] === '绿色产品' ? true : false
        // 绿色产品标签中英文映射
        let greenListMap = [
          {label: '绿色产品', value: 'green_comprehensive'},
          {label: '欧盟分类法绿色产品', value: 'green_eu_taxonomy'},
          {label: '共同分类目录绿色产品', value: 'green_common_ground_taxonomy'},
          {label: '绿色债券绿色产品', value: 'china_green_bond_catalogue'},
          {label: '绿色产业绿色产品', value: 'green_industry_guidance_catalogue'},
          {label: '其他绿色产品', value:'others'},
        ]
        for(let item of self.data){
          const label = self.product_label[self.product_label.length - 1]
          let arr = []
          let arr2 = []
          if (isGreen) {
            const greenLabel = greenListMap.find(item => item.label === self.product_label[self.product_label.length - 1]).value
            arr.push(label)
            if (item[greenLabel].product_name) item.product_and_standard = item[greenLabel].product_name.split(',')
            if (item.product_and_standard) item.product_and_standard = item.product_and_standard.join('\r\n')
            item.max_rev = XEUtils.commafy(XEUtils.toNumber(item[greenLabel].min_revenue)/10000, {digits: 2}) + '-' + XEUtils.commafy(XEUtils.toNumber(item[greenLabel].max_revenue)/10000, {digits: 2})
            item.max_revper = (item[greenLabel].min_percentage).toFixed(2) + '-' + (item[greenLabel].max_percentage).toFixed(2)
            
          } else {
            if (item.product_info_sum) {
              const label_product = item.product_info_sum.filter(item => item.product_label === label && !(item.product_name.includes('其他') && item.product_name.includes('-')))
              item.product_and_standard = label_product.map(item => {
                return {
                  pro: item.product_name,
                  staPro: '【' + item.standardized_product_name + '】'
                }
              })
            }
            for (let k in item.label_calculation) {
              if (k === label) {
                arr.push(k)
                arr2.push(item.label_calculation[k])
              }
            }
          }
          item.product_label = arr.join('、')
          if (!isGreen) {
            item.rev = arr2.reduce((total, item) => total + +item.rev, 0)
            item.revper = arr2.reduce((total, item) => total + +item.revper, 0)
            item.rev_y2y = arr2.reduce((total, item) => total + +item.rev_y2y, 0)
            item.revper_y2y = arr2.reduce((total, item) => total + +item.revper_y2y, 0)
          }
        }
        let page = response.data.page
        self.page.total = page.total
        self.loading=false
      })
      .catch((error)=>{
        self.loading = false
        console.log(error);
      })
    } 
  },
  computed: {
    tableColumn() {
      if (this.isGreen) {
        return [
          {title: 'i18n.common.ticker', field: 'ticker', width: 200, className: 'click-cell-style', sortable: true},
          {title: 'i18n.user_center.entity_name', field: 'full_name', type:"html", className: "click-cell-style",
          formatter: ({row}) => {
            return '<a target="_blank" href="/entity/'+row.full_name+'/revenue/breakdown">'+row.full_name+'</a>'
          }},
          {title: 'i18n.supplychain.fil_year', field: 'start_date', width: 120, sortable: true, formatter: ({cellValue}) => { return cellValue ? this.timestampToTime(cellValue) + '年': ''}},
          {title: 'i18n.supplychain.product_and_standard', field: 'product_and_standard', minWidth: 300, slots: { header: 'product_and_standard' }},
          {title: 'i18n.supplychain.concept_label', field: 'product_label'},
          {title: 'i18n.supplychain.revenue', field: 'max_rev', sortable: true},
          {title: 'i18n.supplychain.revenue_proportion%', field: 'max_revper', sortable: true},
        ]
      } else {
        return [
          {title: 'i18n.common.ticker', field: 'ticker', className: 'click-cell-style', sortable: true},
          {title: 'i18n.user_center.entity_name', field: 'full_name', type:"html", className: "click-cell-style",
          formatter: ({row}) => {
            return '<a target="_blank" href="/entity/'+row.full_name+'/revenue/breakdown">'+row.full_name+'</a>'
          }},
          {title: 'i18n.supplychain.fil_year', field: 'start_date', width: 120, sortable: true, formatter: ({cellValue}) => { return cellValue ? this.timestampToTime(cellValue) + '年': ''}},
          {title: 'i18n.supplychain.product_and_standard', field: 'product_and_standard', minWidth: 300, slots: { header: 'product_and_standard' }, formatter:({cellValue}) => { return cellValue ? cellValue.map(item => item.pro + item.staPro).join('\t\n') : ''}},
          {title: 'i18n.supplychain.concept_label', field: 'product_label'},
          {title: 'i18n.supplychain.revenue', field: 'rev', sortable: true, formatter: ({cellValue}) => { return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue)/10000, {digits: 2})}` : ''}},
          {title: 'i18n.supplychain.revenue_proportion%', field: 'revper', sortable: true, formatter: ({cellValue}) => { return cellValue ? cellValue.toFixed(2) : ''}},
          {title: 'i18n.supplychain.product_label_rev_yearchange', field: 'rev_y2y', sortable: true, formatter: ({cellValue}) => { return cellValue ? cellValue.toFixed(2) : ''}},
          {title: 'i18n.supplychain.product_label_revper_yearchange', field: 'revper_y2y', sortable: true, formatter: ({cellValue}) => { return cellValue ? cellValue.toFixed(2) : ''}}
        ]
      }
    },
    lang() {
      return this.$i18n.locale
    }
  },
  created() {
    // 获取最近12年的年份
    this.getYear(12)
    // 获取行业分类信息和标签
    Promise.all(this.getStatisticsData()).then((res) => {
      this.washTree(this.industry_options)
      this.washTree(this.en_industry_options)
      this.washTree(this.zh_industry_options)
    })
    this.getIndustrialChainFilterData()
  },
  watch: {
    lang(val) {
      if (val === 'zh') {
        this.industry_options = this.zh_industry_options
      } else {
        this.industry_options = this.en_industry_options
      }
    }
  },
  components: { RevenuePropFilter }
}

export default vm


// WEBPACK FOOTER //
// ./src/supplychain/js/IndustrialChainFilter.js